import * as React from 'react'
import { observer } from 'mobx-react'
import LocalizationStore from '../../Stores/LocalizationStore'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import { Button } from 'react-bootstrap'
import HttpActionsService from '../../Services/HttpActionsService'
import { history } from '../../Routing'

@observer
export default class BlamePage extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    ls = LocalizationStore.getInstance()

    schema: Object = {
        'title': LocalizationStore.getInstance().t!('Feedback page'),
        'type': 'object',
        'required': [
            'email',
            'desc'
        ],
        'properties': {
            'email': {
                'title': this.ls.t('Enter e-mail'),
                'type': 'string'
            },
            'desc': {
                'title': 'В чем проблема?',
                'type': 'string',
                'minLength': 1         
            }
        }
    }
    
    submit(e: ISubmitEvent<any>) {
        HttpActionsService.getInstance().sendBlame('blame')
    }
    cancel () {
        history.push('/')
    }

    render() {
        const self = this
        let ls = LocalizationStore.getInstance()

        return (
            <Form
                onSubmit={(e) => self.submit(e)}
                schema={self.schema}
            >
            <div className="">
                <Button type="submit">{ls.t!('BlameBtn')}</Button>
                <Button 
                    bsClass="btn btn-secondary"
                    onClick={self.cancel}
                >
                    {ls.t!('Cancel')}
                </Button>
            </div>  
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/FeedbackPage.tsx